import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersAiCompanyContextsCreateResponseType } from "~/features/ai-customize/types";

type RequestDataType = {
  body: {
    context: string;
  };
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersAiCompanyContextsCreateResponseType>(
      "/api/managers/ai_company_contexts",
      {
        aiCompanyContext: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersAiCompanyContextsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersAiCompanyContextsCreateResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
